import React, { useState }  from 'react';
import  "./About.css";
import { Link } from "react-router-dom";
 
const About = (props) => {

    const [user] = useState(window.localStorage.getItem("authUser"));

    return (
       <div className="row col-md-12">
           <div className="row col-md-12  text-format">
           Hoya Saxas is an exclusive platform for Georgetown Hoyas to connect with other like-minded students.
           We have created an algorithm that matches you with another Hoya based on a series of questions and follow up comments.
           The platform allows you to either accept or reject the suggestions the algorithm provides.
           We believe our algorithm can help you find that special someone on Campus and simplify the dating process just a tab bit.
           Thanks for using Hoya Saxas, and hope you find your ideal match!
           
       <div className="col-md-4 pari-border">
              <img className="hearts" alt='hearts' src='cat.png' />
              <br/>
              Meet Pari our Love Mascot, she uses her secret formulas to make the Magic happen.
                </div>
           <hr/>
           {user ? <div>
       
       <div className="row col-md-12 text-feedback text-background">
      
       <Link to="/feedback">Feedback Form</Link> 
       </div> </div>: ''}
           </div>
           
       </div>
      
    );
}
 
export default About;